import React from 'react';
import { Translate } from 'react-localize-redux';
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
  const navigate = useNavigate();
  const navigateBack = (e) => { e.preventDefault(); navigate(-1); };
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  return <a href="" onClick={navigateBack} className="theme-transparent button--action-before icon--arrow-left"><Translate id="common.back" /></a>;
};

export default BackButton;
